import {ActionsTransform} from "./ActionsTransform";
import {assistantsTransform} from "../assistants/AssistantsTransform";

import {
  CustomEvalActionListModel,
  CustomEvalActionRecordModel,
  CustomEvalActionCreateModel,
  CustomEvalActionUpdateModel,
} from "@/api/models/actions/customEvaluation";
import {
  CustomEvalAction,
  PaginatedResponse,
  CustomEvalCategory,
} from "@/api/services";
import {BaseAction} from "@/types/api";

export class ActionCustomEvalTransform extends ActionsTransform<
  CustomEvalActionRecordModel,
  CustomEvalActionCreateModel,
  CustomEvalActionUpdateModel
> {
  public makeRecordModel(
    dto: CustomEvalAction & BaseAction,
  ): CustomEvalActionRecordModel {
    const model: CustomEvalActionRecordModel = {
      id: dto.action_id,
      action_id: dto.action_id,
      slug: dto.slug,
      type: dto.type,
      title: dto.name,
      icon: dto.icon,
      workspace_id: dto.workspace_id,
      assistants:
        dto.assistants?.map(assistant =>
          assistantsTransform.makeEvenCompactModel(assistant),
        ) || [],
      question: {
        ...dto.question,
        choices: (dto.question.choices || []).map(choice => ({value: choice})),
      },
    };

    return model;
  }

  public makeListModel(dto: PaginatedResponse): CustomEvalActionListModel {
    const model: CustomEvalActionListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as CustomEvalAction & BaseAction),
      ),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }

  public makeCreateDto(model: CustomEvalActionCreateModel): CustomEvalAction {
    const dto: CustomEvalAction = {
      name: model.title,
      type: model.type,
      workspace_id: model.workspace_id,
      icon: model.icon,
      question: {
        identifier: model.title,
        type: "choice",
        text: model.question.text || "",
        category: model.question.category as CustomEvalCategory,
        expected_result: model.question.expected_result,
      },
    };

    return dto;
  }

  public makeUpdateDto(model: CustomEvalActionUpdateModel): CustomEvalAction {
    const dto: CustomEvalAction = {
      name: model.title,
      type: model.type,
      workspace_id: model.workspace_id,
      icon: model.icon,
      question: {
        identifier: model.title,
        type: "choice",
        text: model.question.text || "",
        category: model.question.category as CustomEvalCategory,
        expected_result: model.question.expected_result,
      },
    };

    return dto;
  }
}

export const actionCustomEvalTransform = new ActionCustomEvalTransform();
